import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Head from 'next/head';
import Image from 'next/image';

import accessGold from '@/assets/images/icons/access-gold.svg';
import doorStep from '@/assets/images/icons/door-step.svg';
import goldVault from '@/assets/images/icons/gold-vault.svg';
import homeWhyImage from '@/assets/images/icons/home-why.png';
import processFee from '@/assets/images/icons/process-fee.svg';
import {
  BannerCarousel,
  HomeHero,
  HomeWhy,
  TestimonialCarousel,
} from '@/common/components/digital-gold';
import { Caluclator } from '@/common/components/digital-gold/landingPage/Calculator';
import { Faqcomponent } from '@/common/components/Faq/FaqComponent';
import AllInOne from '@/common/components/Prelogin/AllInOne';
import { rebrandedPreloginDqFaqs } from '@/utils/constants/digital-gold/FaqData';
import { DigitalGoldSEO } from '@/utils/constants/MetaData';

import { DgPoweredBy } from './landingPage';

const LandingPage = ({ setCurrentStep: _setCurrentStep }: any) => {
  return (
    <>
      <Head>
        <title>{DigitalGoldSEO.metaTitle}</title>
        <meta name="description" content={DigitalGoldSEO.metaDescription} />
        <meta
          property="og:description"
          content={DigitalGoldSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/eSwarna-digital-gold/"
        />
      </Head>
      <main className="home withHeader">
        <HomeHero />
        <BannerCarousel />

        {/* Ltv caluclator */}
        <Caluclator />

        <section className="with-padding home__safe">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h2 className="text--black section__title">
                  Why eSwarna {/* <span className="text--yellow"> */}
                  Digital Gold?
                  {/* </span> */}
                </h2>
                <p className="text--gray text--regular section__desc">
                  Buy eSwarna digital gold online as it is a cost-effective and
                  convenient way of purchasing gold online in fractions of the
                  amount as low as Re. 1{/* ₹1. */}
                </p>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-6 safe__card-col">
                    <div className="safe__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={doorStep}
                        alt="30 minutes door step service"
                      />
                      <p className="text--gray text--regular title">
                        You have the luxury to buy gold at anytime from anywhere
                      </p>
                    </div>
                  </div>
                  <div className="col-6 safe__card-col">
                    <div className="safe__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={goldVault}
                        alt="gold vault"
                      />
                      <p className="text--gray text--regular title">
                        Unlike physical gold, you don’t have to worry about
                        theft
                      </p>
                    </div>
                  </div>
                  <div className="col-6 safe__card-col mb-0">
                    <div className="safe__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={processFee}
                        alt="process fee"
                      />
                      <p className="text--gray text--regular title">
                        There are no making charges incurred for Gold
                      </p>
                    </div>
                  </div>
                  <div className="col-6 safe__card-col mb-0">
                    <div className="safe__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={accessGold}
                        alt="access-gold"
                      />
                      <p className="text--gray text--regular title">
                        The process is safe and easy
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <HomeWhy
          // title={`Why buy <span className='text--yellow'>Digital Gold</span> with ONE Muthoot?`}
          desc="The Muthoot Pappachan Group, with a reputation that has been shaped over decades with high quality practices, total customer satisfaction and steady growth."
          bannerImageSrc={homeWhyImage}
          bannerImageAlt="Digital Gold | Muthoot FinCorp ONE"
        />
        {/* <section className="with-padding home__control">
        <div className="static-cards-container container">
          <h2 className="text--black text--bold section__title-small text-center">
            Complete control of your{' '}
            <span className="text--yellow">Digital Gold</span>
          </h2>
          <div className="home__video--slider home-scheme-margin">
            <Slider {...videoSettings} className="test-carousel2">
              <div className="home__control__card darkBlue static-card">
                <Image 
style={{ color: undefined }}
                  className="img-fluid icon"
                  src={autoPayIcon}
                  alt="autopay icon"
                />
                <p className="text--white text--bold title">
                  Automate your savings
                </p>
                <p className="text--white text--regular desc">
                   style={{height:'92px',flexWrap:'wrap'}} 
                  Make saving a habit with SIP. Automate the process of buying
                  digital gold and see it grow over time.
                </p>
                <a
                  href="#"
                  className="custom__button custom__button--white border-btn"
                >
                  Start SIP
                </a>
              </div>
              <div className="home__control__card lightBlue static-card">
                <Image 
style={{ color: undefined }}
                  className="img-fluid icon"
                  src={convertIcon}
                  alt="convert icon"
                />
                <p className="text--black text--bold title">
                  Convert to coin and jewellery
                </p>
                <p className="text--gray text--regular desc">
                  You can convert your digital gold to physical gold anytime in
                  the form of coins or jewellery of your choice and get it
                  delivered at your doorstep.
                </p>
                <a
                  href="#"
                  className="custom__button custom__button--black border-btn"
                >
                  View Catalogue
                </a>
              </div>
              <div className="home__control__card ultraLightBlue static-card">
                <Image 
style={{ color: undefined }}
                  className="img-fluid icon"
                  src={sellIcon}
                  alt="sell icon"
                />
                <p className="text--black text--bold title">
                  Sell instantly at a click{' '}
                </p>
                <p className="text--gray text--regular desc">
                  Your digital gold is safe with us, and you can withdraw it at
                  any time and receive money direct in your account.
                </p>
                <a
                  // href="#"
                  onClick={() => router.push(routes.sellGoldLanding)}
                  className="custom__button custom__button--black border-btn"
                >
                  Sell Now
                </a>
              </div>
            </Slider>
          </div>
        </div>
      </section>
      <section className="bg bg--yellow safely">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <h2 className="section__title text--black text--bold">
                <span className="text--darkBlue">Safely</span> Convert to
                physical gold
              </h2>
              <p className="section__desc text--black text--regular">
                You can very simply convert your Digital Gold to gold coin or
                jewellery in few easy steps and get it delivered at your
                doorstep.
              </p>
            </div>
            <div className="col-lg-7">
              <div className="row safely__row">
                <div className="col-md-4 col-6">
                  <a href="#" className="safely__card">
                    <Image 
style={{ color: undefined }} className="img-fluid" src={coin} alt="Gold Coins" />
                    <p className="title text--bold text--black">Coins</p>
                  </a>
                </div>
                <div className="col-md-4 col-6">
                  <a href="#" className="safely__card">
                    <Image 
style={{ color: undefined }} className="img-fluid" src={pendent} alt="pendant" />
                    <p className="title text--bold text--black">Pendants</p>
                  </a>
                </div>
                <div className="col-md-4 col-6">
                  <a href="#" className="safely__card">
                    <Image 
style={{ color: undefined }} className="img-fluid" src={earing} alt="Earing" />
                    <p className="title text--bold text--black">Earrings</p>
                  </a>
                </div>
                <div className="col-md-4 col-6">
                  <a href="#" className="safely__card mb-md-0">
                    <Image 
style={{ color: undefined }} className="img-fluid" src={pendent} alt="pendant" />
                    <p className="title text--bold text--black">Pendants</p>
                  </a>
                </div>
                <div className="col-md-4 col-6">
                  <a href="#" className="safely__card mb-0">
                    <Image 
style={{ color: undefined }} className="img-fluid" src={earing} alt="earing" />
                    <p className="title text--bold text--black">Earrings</p>
                  </a>
                </div>
                <div className="col-md-4 col-6">
                  <a href="#" className="safely__card more mb-0">
                    <Image 
style={{ color: undefined }}
                      className="img-fluid"
                      src={viewMore}
                      alt="view more"
                    />
                    <p className="title text--bold text--white">+7 more</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
        {/* videos section */}
        {/* <section className="bg bg--ultraLight">
        <div className="home__video">
          <div className="container">
            <h2 className="section__title-small text--bold text--black">
              Learn more through our videos
            </h2>
          </div>
          <VideosSection />
        </div>
      </section> */}
        {/* testimonial */}

        <section className="bg bg--light mt-5">
          <div className="home__customer">
            <div className="container">
              <h2 className="section__title-small text--bold text--black text-center">
                The Customer Is Always Right
              </h2>
              <p className="section__desc text--gray text-center">
                Trust is a key component to the way we treat our customers
              </p>
            </div>

            <TestimonialCarousel />
          </div>
        </section>
        {/* testimonial ends */}
        <AllInOne />
        {/*
      <HomeDownloadCta
        title={`Download India’s Most Trusted <span className='text--yellow'>Digital Gold App</span>`}
        desc="The Muthoot Pappachan Group, with a reputation that has been shaped over decades with high quality practices, total customer satisfaction and steady growth."
        googleStoreLink="#"
        appleStoreLink="#"
        bannerImageSrc={digitalGoldApp}
        bannerImageAlt="Digital Gold App | One Muthoot"
      /> */}
        {/* <section className="home__faq with-padding">
        <div className="container">
          <h2 className="section__title-small text--black text--bold">
            Frequently Asked Questions
          </h2> 
      {faqList.map((each) => (
      <Faqcomponent faqData={faqList()} /> 
       ))}
      </div>
      </section>  */}
        {/* FAQS SECTION */}
        <Faqcomponent faqData={rebrandedPreloginDqFaqs()} />
        <div className="d-flex justify-content-center h-100 mb-5">
          <DgPoweredBy />
        </div>
      </main>
    </>
  );
};
export default LandingPage;
